module.exports = __webpack_public_path__ + "static/media/joshua-earlesz.1ac76a13.jpg";